module.exports = __webpack_public_path__ + "img/thumb_27.2fc6193b.jpg";